import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Amplify } from "aws-amplify";

import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { persistor, store } from "./app/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

/**
 * Dev-only: /video-test skips Cognito so privacy chaos checks can run locally.
 * Must stay NODE_ENV-gated — never ship an unauthenticated path in production.
 */
const bypassAuthForVideoTest =
  process.env.NODE_ENV === "development" &&
  typeof window !== "undefined" &&
  window.location.pathname === "/video-test";

const appTree = (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    {bypassAuthForVideoTest ? (
      appTree
    ) : (
      <Authenticator hideSignUp>{appTree}</Authenticator>
    )}
  </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
